export default __webpack_public_path__ + "assets/pdf/IndigeNFT_Roadmap_22.22b6524f.pdf";